export const getUrlIdentifier = (values: readonly { id: string; urlIdentifier: string }[], selectedId: string): string | undefined =>
    values.find((value: { id: string }) => value.id === selectedId)?.urlIdentifier;
